// extracted by mini-css-extract-plugin
export default {"container":"Signup__container___WI0VX","smallerPadding":"Signup__smallerPadding___O_IEr Signup__container___WI0VX"};